import React from 'react'
import {Formik, Form} from 'formik'
import * as yup from 'yup'
import {toast} from 'react-toastify'
import {Typography, Grid} from '@material-ui/core'

import ImageComponent from './ImageComponentNew'
import {REGEX_NUMBER_ONLY} from '../../../../../../constant'

import {
  GRID_CONTAINER_SPACING,
  GridItem,
  SectorContainer,
  SaveButton,
  FormikTextField,
} from './common'

const validationSchema = isShowTaxInfo => {
  return yup.object({
    shopName: yup.string().required('กรุณาใส่ชื่อร้านค้า'),
    address: isShowTaxInfo
      ? yup.string().required('กรุณาใส่ที่อยู่')
      : yup.string(),
    subDistrict: isShowTaxInfo
      ? yup.string().required('กรุณาใส่ข้อมูลแขวง')
      : yup.string(),
    district: isShowTaxInfo
      ? yup.string().required('กรุณาใส่ข้อมูลอำเภอ')
      : yup.string(),
    province: isShowTaxInfo
      ? yup.string().required('กรุณาใส่ข้อมูลจังหวัด')
      : yup.string(),
    postcode: isShowTaxInfo
      ? yup
          .string()
          .length(5, 'กรุณาใส่รหัสไปรษณีย์ 5 หลัก')
          .matches(REGEX_NUMBER_ONLY, {message: 'กรุณาใส่ตัวเลขเท่านั้น'})
          .required('กรุณาใส่รหัสไปรษณีย์ 5 หลัก')
      : yup
          .string()
          .length(5, 'กรุณาใส่รหัสไปรษณีย์ 5 หลัก')
          .matches(REGEX_NUMBER_ONLY, {message: 'กรุณาใส่ตัวเลขเท่านั้น'}),
    phoneNumber: isShowTaxInfo
      ? yup
          .string()
          .matches(REGEX_NUMBER_ONLY, {
            message: 'กรุณาใส่ตัวเลขเท่านั้น',
          })
          .required()
      : yup.string().matches(REGEX_NUMBER_ONLY, {
          message: 'กรุณาใส่ตัวเลขเท่านั้น',
        }),
  })
}

class ShopDetailSector extends React.Component {
  render() {
    return (
      <SectorContainer>
        <Formik
          enableReinitialize
          initialValues={this.props.value}
          onSubmit={(values, {setSubmitting}) => {
            this.props
              .onSave({
                variables: {
                  projectId: this.props.project.id,
                  detail: {
                    image: values.image,
                    general: {
                      name: values.shopName,
                      phoneNumber: values.phoneNumber,
                      address: {
                        address_1: values.address,
                        subDistrict: values.subDistrict,
                        district: values.district,
                        province: values.province,
                        postcode: values.postcode,
                        branch: values.branch,
                      },
                    },
                    socialMedia: {
                      facebook: values.facebook,
                      instagram: values.instagram,
                      twitter: values.twitter,
                      website: values.website,
                    },
                  },
                },
              })
              .then(re => {
                setSubmitting(false)
                toast.success('บันทึกข้อมูลร้านค้าเรียบร้อยแล้ว', {
                  hideProgressBar: true,
                  position: toast.POSITION.BOTTOM_RIGHT,
                })
              })
          }}
          validationSchema={() => validationSchema(this.props.isShowTaxInfo)}
          render={props => {
            const {
              isSubmitting,
              handleChange,
              handleBlur,
              setFieldValue,
              touched,
              errors,
              values,
            } = props
            return (
              <Form>
                <Typography variant="headline" gutterBottom>
                  ข้อมูลร้านค้า
                </Typography>
                <Grid container spacing={GRID_CONTAINER_SPACING}>
                  <GridItem item xs={12} sm={12}>
                    <Typography variant="title" gutterBottom>
                      ข้อมูลทั่วไป
                    </Typography>
                  </GridItem>
                  <GridItem item xs={12} sm={6}>
                    <ImageComponent
                      disabled={this.props.disabled}
                      value={values.image}
                      project={this.props.project}
                      onChange={imageURL => setFieldValue('image', imageURL)}
                    />
                  </GridItem>
                </Grid>
                <Grid container spacing={GRID_CONTAINER_SPACING}>
                  <GridItem item xs={12} sm={6}>
                    <FormikTextField
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      disabled={this.props.disabled}
                      id="shopName"
                      name="shopName"
                      value={values.shopName}
                      label="ชื่อร้านค้า"
                      fullWidth
                    />
                  </GridItem>
                  <GridItem item xs={12} sm={12}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="address"
                      disabled={this.props.disabled}
                      name="address"
                      value={values.address}
                      label="ที่อยู่"
                      fullWidth
                    />
                  </GridItem>
                </Grid>
                <Grid container spacing={GRID_CONTAINER_SPACING}>
                  <GridItem item xs={12} sm={3}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="subDistrict"
                      disabled={this.props.disabled}
                      name="subDistrict"
                      value={values.subDistrict}
                      label="แขวง"
                      fullWidth
                    />
                  </GridItem>
                  <GridItem item xs={12} sm={3}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="district"
                      disabled={this.props.disabled}
                      name="district"
                      value={values.district}
                      label="เขต"
                      fullWidth
                    />
                  </GridItem>
                  <GridItem item xs={12} sm={3}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="province"
                      disabled={this.props.disabled}
                      name="province"
                      value={values.province}
                      label="จังหวัด"
                      fullWidth
                    />
                  </GridItem>
                  <GridItem item xs={12} sm={3}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="postcode"
                      disabled={this.props.disabled}
                      name="postcode"
                      value={values.postcode}
                      label="รหัสไปรษณีย์"
                      fullWidth
                    />
                  </GridItem>
                </Grid>
                <Grid container spacing={GRID_CONTAINER_SPACING}>
                  <GridItem item xs={12} sm={3}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="branch"
                      disabled={this.props.disabled}
                      name="branch"
                      value={values.branch}
                      label="สาขา"
                      fullWidth
                    />
                  </GridItem>
                  <GridItem item xs={12} sm={3}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="phoneNumber"
                      disabled={this.props.disabled}
                      name="phoneNumber"
                      value={values.phoneNumber}
                      label="เบอร์โทรศัพท์"
                      fullWidth
                    />
                  </GridItem>
                </Grid>
                <Grid container spacing={GRID_CONTAINER_SPACING}>
                  <GridItem item xs={12}>
                    <Typography variant="title">Social media</Typography>
                  </GridItem>
                  <GridItem item xs={12} sm={3}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="facebook"
                      disabled={this.props.disabled}
                      name="facebook"
                      value={values.facebook}
                      label="facebook"
                      fullWidth
                    />
                  </GridItem>
                  <GridItem item xs={12} sm={3}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="instagram"
                      disabled={this.props.disabled}
                      name="instagram"
                      value={values.instagram}
                      label="instagram"
                      fullWidth
                    />
                  </GridItem>
                  <GridItem item xs={12} sm={3}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="twitter"
                      disabled={this.props.disabled}
                      name="twitter"
                      value={values.twitter}
                      label="twitter"
                      fullWidth
                    />
                  </GridItem>
                  <GridItem item xs={12} sm={3}>
                    <FormikTextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      id="website"
                      disabled={this.props.disabled}
                      name="website"
                      value={values.website}
                      label="website"
                      fullWidth
                    />
                  </GridItem>
                </Grid>
                <Grid
                  container
                  direction="row-reverse"
                  spacing={GRID_CONTAINER_SPACING}
                >
                  <GridItem item xs={12} sm={3}>
                    <SaveButton
                      type="submit"
                      variant="contained"
                      disabled={isSubmitting || this.props.disabled}
                      fullWidth
                    >
                      Save
                    </SaveButton>
                  </GridItem>
                </Grid>
              </Form>
            )
          }}
        />
      </SectorContainer>
    )
  }
}

export default ShopDetailSector



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/storeSettings/components/ShopDetailSector.js